<template>
    <div class="page-table  mainDiv " id="affix-container">
        <el-steps :active="active" finish-status="success" simple class="bg-white padding-20">
            <el-step title="Firma Bilgileri" icon="el-icon-edit"></el-step>
            <el-step title="Yönetici Bilgileri" icon="el-icon-upload">
            </el-step>
        </el-steps>
        <el-col v-if="active ===0" :lg="24" :md="24" :sm="24" :xs="24">
            <div class="animated fadeInUp">
                <el-form status-icon :model="firmaForm" :rules="rulesFirma" ref="firmaForm">
                    <el-row :gutter="10">
                        <el-col :lg="12" :md="12" :sm="24" :xs="24">
                            <div class="card-base card-shadow--medium">
                                <el-divider content-position="left">Firma Bilgileri</el-divider>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.firma.tanimlama.firmaAdi")'
                                                      prop="firmaAdi">:
                                            <el-input
                                                    v-on:change="$store.commit('changeTabsClose', false)"
                                                    v-model="firmaForm.firmaAdi" v-on:input="inputStyleAlt"
                                                    :placeholder='$t("src.views.apps.firma.tanimlama.firmaPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.firma.tanimlama.firmaKodu")'
                                                      prop="firmaKodu">:
                                            <el-input
                                                    v-on:change="$store.commit('changeTabsClose', false)"

                                                    v-model="firmaForm.firmaKodu"
                                                    v-mask="'AAA####'"
                                                    :placeholder='$t("src.views.apps.firma.tanimlama.firmaKoduPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.firma.tanimlama.vergiDairesi")'
                                                      prop="vergiDairesi">:
                                            <el-input
                                                    v-on:change="$store.commit('changeTabsClose', false)"

                                                    v-model="firmaForm.vergiDairesi"
                                                    :placeholder='$t("src.views.apps.firma.tanimlama.vergiDairesiPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.firma.tanimlama.vergiNo")'
                                                      prop="vergiNo">:
                                            <el-input
                                                    v-on:change="$store.commit('changeTabsClose', false)"

                                                    v-model="firmaForm.vergiNo"
                                                    v-mask="'##########'"
                                                    :placeholder='$t("src.views.apps.firma.tanimlama.vergiNoPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-col>
                        <el-col :lg="12" :md="12" :sm="24" :xs="24">
                            <div class="card-base card-shadow--medium">
                                <el-divider content-position="left">Site Bilgileri</el-divider>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.firma.tanimlama.siteAdi")'
                                                      prop="siteAdi">:
                                            <el-input
                                                    v-on:change="$store.commit('changeTabsClose', false)"
                                                    v-model="firmaForm.siteAdi"
                                                    :placeholder='$t("src.views.apps.firma.tanimlama.siteAdiPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.firma.tanimlama.slogan")'
                                                      prop="slogan">:
                                            <el-input
                                                    v-on:change="$store.commit('changeTabsClose', false)"

                                                    v-model="firmaForm.slogan"
                                                    :placeholder='$t("src.views.apps.firma.tanimlama.sloganPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.firma.tanimlama.siteAdresi")'
                                                      prop="siteAdresi">:
                                            <el-input
                                                    v-on:change="$store.commit('changeTabsClose', false)"

                                                    v-model="firmaForm.siteAdresi"
                                                    :placeholder='$t("src.views.apps.firma.tanimlama.siteAdresiPlace")'>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.firma.tanimlama.siteAdresi2")'
                                                      prop="siteAdresi2">:
                                            <el-input
                                                    v-on:change="$store.commit('changeTabsClose', false)"

                                                    v-model="firmaForm.siteAdresi2" class="input-with-select"
                                                    :placeholder='$t("src.views.apps.firma.tanimlama.siteAdresiPlace")'>
                                                <el-select v-on:change="$store.commit('changeTabsClose', false)"
                                                           v-model="select" slot="prepend" placeholder="Select">
                                                    <el-option label="http://" value="1"></el-option>
                                                    <el-option label="https://" value="2"></el-option>
                                                </el-select>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="card-base card-shadow--medium" style="margin-top: 10px">
                        <el-divider content-position="left">İletişim Bilgileri</el-divider>
                        <el-row style="margin-top: 10px">
                            <el-col :lg="12" :md="12" :sm="12" :xs="12" class="col-p">
                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.eposta")' prop="eposta">:
                                    <el-input
                                            v-on:change="$store.commit('changeTabsClose', false)"

                                            type="email"
                                            v-model="firmaForm.eposta"
                                            placeholder='info@erasmus.com.tr'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="12" :md="12" :sm="12" :xs="12" class="col-p">
                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.eposta2")' prop="eposta2">:
                                    <el-input
                                            v-on:change="$store.commit('changeTabsClose', false)"

                                            type="email"
                                            v-model="firmaForm.eposta2"
                                            placeholder='info@erasmus.com.tr'></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="8" :md="8" :sm="12" :xs="12" class="col-p">
                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.telefon")' prop="telefon">:
                                    <el-input
                                            v-on:change="$store.commit('changeTabsClose', false)"

                                            v-model="firmaForm.telefon" v-mask="'+90(###)### ## ##'"
                                            placeholder="+90(555)555 55 55"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="5" :md="5" :sm="12" :xs="12" class="col-p">
                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.telefon2")'
                                              prop="sabitTelefon">:
                                    <el-input
                                            v-on:change="$store.commit('changeTabsClose', false)"

                                            v-model="firmaForm.sabitTelefon" v-mask="'+90(###)### ## ##'"
                                            placeholder="+90(346)555-5555"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="3" :md="3" :sm="12" :xs="12" class="col-p">
                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.dahili")' prop="dahili">:
                                    <el-input
                                            v-on:change="$store.commit('changeTabsClose', false)"

                                            v-model="firmaForm.dahili" v-mask="'######'"
                                            placeholder="555555"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="8" :md="8" :sm="12" :xs="12" class="col-p">
                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.fax")' prop="fax">:
                                    <el-input
                                            v-on:change="$store.commit('changeTabsClose', false)"

                                            v-model="firmaForm.fax" v-mask="'+90(346)### ## ##'"
                                            placeholder="+90(346)555-5555"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.adres")' prop="adres">:
                                    <el-input
                                            v-on:change="$store.commit('changeTabsClose', false)"
                                            type="textarea" v-model="firmaForm.adres"></el-input>
                                </el-form-item>
                                <el-form-item :label='$t("Adres2")' prop="adres2">:
                                    <el-input
                                            v-on:change="$store.commit('changeTabsClose', false)"
                                            type="textarea" v-model="firmaForm.adres2"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.koordinat")'
                                              prop="koordinat">:
                                    <el-input
                                            v-on:change="$store.commit('changeTabsClose', false)"
                                            v-model="firmaForm.koordinat"
                                            placeholder="39.707540, 37.041967"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.map")' prop="map">:
                                    <el-input
                                            v-on:change="$store.commit('changeTabsClose', false)"
                                            type="textarea" v-model="firmaForm.map"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.firma.tanimlama.sosyal")' prop="valueAna">
                                    <el-select v-on:change="$store.commit('changeTabsClose', false)"
                                               v-model="valueAna"
                                               style="width: 100%"
                                               multiple
                                               filterable
                                               allow-create
                                               default-first-option
                                               placeholder="Facebook, Instagram, Twitter...">
                                        <el-option
                                                v-for="item in options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-for="(detay,index) in valueAna" v-bind:key="index">
                            <el-col :span="24" class="col-p">
                                <el-form-item :label='detay.label'>:
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-input
                                                    v-model="firmaForm[detay.value]"
                                                    :prop='firmaForm[detay.value]'
                                                    v-on:change="$store.commit('changeTabsClose', false);sosyalKontrol(detay.value)"></el-input>
                                        </el-col>
                                        <el-col :span="10">
                                            <el-button
                                                    type="danger"
                                                    size="mini"
                                                    icon="el-icon-close"
                                                    v-on:click="removeRowFirma(index,detay.value)">
                                            </el-button>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
        </el-col>
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="float: right;margin-top: 15px;"
                       @click="save">Kaydet
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import firmaService from '../../../WSProvider/FirmaService';
    import yoneticiService from '../../../WSProvider/YoneticiService';
    import Password from 'vue-password-strength-meter'
    import notification from '../../../notification'
    import JQuery from 'jquery';

    let $ = JQuery;

    let base64 = require('base64_js');
    let userDataExon = "";
    export default {
        name: "FirmaKayit",
        components: {Password},
        mounted() {

        },
        data() {
            return {
                active: 0,
                options: [{
                    value: 'facebook', label: 'Facebook'
                }, {value: 'twitter', label: 'Twitter'}, {value: 'google', label: 'Google'}, {
                    value: 'instagram',
                    label: 'Instagram'
                }, {value: 'linkedin', label: 'LinkedIn'}, {value: 'youtube', label: 'YouTube'}, {
                    value: 'swarm',
                    label: 'Swarm'
                }, {value: 'watsapp', label: 'WhatsApp'}, {value: 'skype', label: 'Skype'},],
                valueAna: [],
                select: '1',
                firmaKodu: '',
                sosyalMedya: [],
                steps: [
                    {
                        label: 'Firma Bilgileri',
                        slot: 'page1',
                    },
                    {
                        label: 'Firma Yöneticisi',
                        slot: 'page2',
                    }
                ],
                firmaForm: {
                    firmaKodu: '',
                    renk: '',
                    keyword: '',
                    firmaAdi: '',
                    siteAdi: '',
                    vergiDairesi: '',
                    vergiNo: '',
                    slogan: '',
                    siteAdresi: '',
                    siteAdresi2: '',
                    eposta: '',
                    eposta2: '',
                    telefon: '',
                    sabitTelefon: '',
                    dahili: '',
                    fax: '',
                    adres: '',
                    adres2: '',
                    koordinat: '',
                    map: '',
                    sosyal: {
                        facebook: '',
                        twitter: '',
                        google: '',
                        instagram: '',
                        linkedin: '',
                        youtube: '',
                        swarm: '',
                        watsapp: '',
                        skype: '',
                    },
                },
                rulesFirma: {
                    firmaKodu: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                    firmaAdi: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                },


            }
        },
        methods: {
            save() {
                this.firmaTanimla();
            },
            inputStyleAlt(val) {
                var splitStr = val.toLowerCase().split(' ');
                for (var i = 0; i < splitStr.length; i++) {
                    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
                }
                this.firmaForm.firmaAdi = splitStr.join(' ');
            },
            sosyalKontrol(sosyal) {
                this.sosyalMedya.push({
                    [sosyal]: this.firmaForm[sosyal],
                })
            },
            removeRowFirma(item, value) {
                this.valueAna.splice(item, 1);
                for (var i = 0; i < this.sosyalMedya.length; i++) {
                    if (value === this.sosyalMedya[i].title) {
                        this.sosyalMedya.splice(i, 1);
                    }
                }
            },
            imageUpload(file) {
                $('.el-upload--picture-card').hide();
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    let name = randomText(7);
                    var imgName = name + '-' + file.name;
                    this.yoneticiForm.image = imgName;
                    const files = file.raw;
                    if (files) {
                        const reader = new FileReader();
                        reader.onload = e => {
                            this.yoneticiForm.imageBase = e.target.result;
                        }
                        reader.readAsDataURL(files);
                    }
                } else {
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            imageRemove() {
                $('.el-upload--picture-card').show();
            },
            firmaTanimla() {
                this.$refs.firmaForm.validate((valid) => {
                    if (valid) {
                        var siteAdresi2 = '';
                        if (this.firmaForm.siteAdresi2) {
                            switch (this.select) {
                                case '1' :
                                    siteAdresi2 = "http://" + this.firmaForm.siteAdresi2;
                                    break;
                                case '2' :
                                    siteAdresi2 = "https://" + this.firmaForm.siteAdresi2;
                                    break;
                            }
                        }
                        firmaService.firmaTanimlama(this.firmaForm.firmaKodu, this.firmaForm.firmaAdi, this.firmaForm.siteAdi,
                            this.firmaForm.vergiDairesi, this.firmaForm.vergiNo, this.firmaForm.slogan,this.firmaForm.keyword, this.firmaForm.siteAdresi,
                            siteAdresi2, this.firmaForm.renk, this.firmaForm.eposta, this.firmaForm.eposta2, this.firmaForm.telefon,
                            this.firmaForm.sabitTelefon, this.firmaForm.dahili, this.firmaForm.fax, this.firmaForm.adres,this.firmaForm.adres2,
                            this.firmaForm.koordinat, this.firmaForm.map, this.sosyalMedya
                        ).then((response) => {
                            if (response.status === 200) {
                                notification.Status('success', this, 'Firma başarıyla eklendi.');
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile bir firma zaten kayıtlı!!');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    } else {
                        notification.Status('warning', this, 'Doldurulması zorunlu olan alanları gözden geçiriniz!!');
                        return false;
                    }
                });

            }

        }
    }

    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return bugun + "-" + text;
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables';

    .aciklamaSpan {
        position: absolute;
        top: 25px;
    }

    label {
        font-size: 12px;
    }

    .page-table {
        &.overflow {
            overflow: hidden;
        }

        .table-box {
            overflow: hidden;
        }
    }

    .el-form-item {
        font-weight: bold;
    }

</style>
